<template>
    <div class="container">
      <ts-loading-banner :loading="waiting">
        <form class="form-horizontal">
          <div class="row">
            <div class="col-md-6">
              <div class="row mb-2">
                <label class="col-form-label col-md-4 required">{{
                  $t('invoice.studentName')
                }}</label>
                <div class="col-md-8">
                  <input
                    type="text"
                    readonly
                    class="form-control-plaintext"
                    :value="studentInfo ? studentInfo.full_name_en : null"
                  />
                  <div class="validate" v-if="errors.has('student_id')">
                    {{ errors.first('student_id') }}
                  </div>
                </div>
              </div>
              <div class="row mb-2">
								<label class="col-form-label col-md-4 required">{{
									$t('invoice.mainProgram')
                }}</label>
                <div class="col-md-8">
									<input
									type="text"
									readonly
									class="form-control-plaintext"
									:value="studentInfo ? studentInfo.acp_name_foreign : null"
                  />
                  <div class="validate" v-if="errors.has('acp_id')">
										{{ errors.first('acp_id') }}
                  </div>
                </div>
              </div>
							<div class="row mb-2">
								<label class="col-form-label col-md-4 required">{{
									$t('invoice.subProgram')
								}}</label>
								<div class="col-md-8">
									<input
										type="text"
										readonly
										class="form-control-plaintext"
										:value="studentInfo ? studentInfo.acps_name_foreign : null"
									/>
									<div class="validate" v-if="errors.has('acps_id')">
										{{ errors.first('acps_id') }}
									</div>
								</div>
							</div>
							<div class="row mb-2">
                <label class="col-form-label col-md-4 required">{{
                  $t('invoice.level')
                }}</label>
                <div class="col-md-8">
                  <a-select
                    style="width: 100%"
                    v-model="model.level_id"
                    :options="levels"
                  ></a-select>
                  <div class="validate" v-if="errors.has('level_id')">
                    {{ errors.first('level_id') }}
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <label class="col-form-label col-md-4 required">{{
                  $t('invoice.grade')
                }}</label>
                <div class="col-md-8">
                  <a-select
                    style="width: 100%"             
                    v-model="model.grade_id"
                    :options="grades"
                  ></a-select>
                  <div class="validate" v-if="errors.has('grade_id')">
                    {{ errors.first('grade_id') }}
                  </div>
                </div>
              </div>
							<div class="row mb-2">
                <label class="col-form-label col-md-4 required">{{
                  $t('invoice.year')
                }}</label>
                <div class="col-md-8">
                  <a-select
                    style="width: 100%"
                    v-model="model.year"
                    :options="years"
                  ></a-select>
                  <div class="validate" v-if="errors.has('year')">
                    {{ errors.first('year') }}
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <label class="col-form-label col-md-4 required">{{
                  $t('invoice.semester')
                }}</label>
                <div class="col-md-8">
                  <a-select
                    style="width: 100%"             
                    v-model="model.semester"
                    :options="semesters"
                  ></a-select>
                  <div class="validate" v-if="errors.has('semester')">
                    {{ errors.first('semester') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row mb-2">
                <label class="col-form-label col-md-4 required">{{
                  $t('invoice.invoiceDate')
                }}</label>
                <div class="col-md-8">
                  <a-date-picker
                    :style="{ width: '100%' }"
                    format="DD-MM-YYYY"
                    valueFormat="DD-MM-YYYY"
                    v-model="model.inv_date"
                    :disabled-date="disabledPastDates"
                  />
                  <div class="validate" v-if="errors.has('inv_date')">
                    {{ errors.first('inv_date') }}
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <label class="col-form-label col-md-4">{{
                  $t('invoice.remark')
                }}</label>
                <div class="col-md-8">
                  <textarea
                    v-model="model.remark"
                    rows="3"
                    class="form-control"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </form>
      </ts-loading-banner>
    </div>
  </template>
  <script>

  import { mapActions } from 'vuex'
  import { Errors } from 'form-backend-validation'
  
  export default {
    name: 'academicInfo',
    props: ['value', 'studentInfo', 'validate'],
    data() {
      return {
        waiting: false,
        model: {},
        errors: new Errors(),
        levels: [],
        grades: [],
        years: [
          {
            value: 'YEAR I',
            label: 'YEAR I'
          },
          {
            value: 'YEAR II',
            label: 'YEAR II'
          }, 
          {
            value: 'YEAR III',
            label: 'YEAR III'
          }, 
          {
            value: 'YEAR IV',
            label: 'YEAR IV'
          }
        ],
        semesters: [
          {
            value: 'SEMESTER I',
            label: 'SEMESTER I'
          },
          {
            value: 'SEMESTER II',
            label: 'SEMESTER II'
          },
        ],
      }
    },
    created() {
      this.model = this.value
    },
    methods: {
      ...mapActions('officailReceiptModule', ['onGetLevel', 'onGetGradeByLevel']),
      fetchLevels() {
          this.levels = []
          this.onGetLevel({
            acps_id: this.studentInfo.acps_id,
            level_id: this.model.level_id,
          })
            .then(response => {
              this.levels = response.data.data
              .map(el => ({
                value: el.level_id,
                label: el.level_name_foreign
              }))
            })
        },
      fetchGrades() {
          this.grades = []
          this.onGetGradeByLevel({
            level_id: this.model.level_id,
          })
            .then(response => {
              this.grades = response.data.data
              .map(el => ({
                value: el.grade_id,
                label: el.grade_name_foreign
              }))
            })
      },
      disabledPastDates(current) {
        // Disable all dates before today
        return current && current < new Date().setHours(0, 0, 0, 0);
      }
    },
    watch: {
      studentInfo: function() {
        this.fetchLevels()
        this.fetchGrades()
      },
      validate: function(error) {
        this.errors = new Errors(error.errors)
      }
    }
  }
  </script>
  
  <style lang="css" scoped>
  .container {
    max-height: 35vh;
    height: 30vh;
  }
  </style>
  